<template >
  <div class="formPosition" v-role="roles">
    <template>
      <v-container class="grey lighten-5">
        <v-row style="align-items: center;">
          <v-col cols="2" sm="2" md="2"><span>Selecione a classe </span> <v-icon large color="green darken-2">forward</v-icon></v-col>
          <v-col cols="7" sm="7" md="7" class="text-center">
            <v-btn @click="classe(1)" class="ma-2" outlined color="indigo"><v-icon small color="primary">filter_1</v-icon> 10ª classe</v-btn>
            <v-btn @click="classe(2)" class="ma-2" outlined color="indigo"><v-icon small color="primary">filter_2</v-icon> 11ª classe</v-btn>
            <v-btn @click="classe(3)" class="ma-2" outlined color="indigo"><v-icon small color="primary">filter_3</v-icon> 12ª classe</v-btn>
            <v-btn @click="classe(4)" class="ma-2" outlined color="indigo"><v-icon small color="primary">filter_4</v-icon> 13ª classe</v-btn>
          </v-col>
          <v-col cols="2" sm="2" md="2">
            <v-select :items="Listaranoslectivo" v-model="anolectivoSelected" item-value="descricao"
              item-text="novadescricao" label="Selecione o Ano lectivo" @change="filtrarAnoLectivo()" return-object>
            </v-select>
          </v-col>

          <v-col cols="1" sm="1" md="1">
            <v-btn :to="rotaBack" color="blue" fab small> <v-icon small color="white">arrow_back</v-icon> </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </div>
</template>

<script>
import axios from '../../plugins/axios'
const ls = require('local-storage')
export default {

  data: () => ({
    anolectivoSelected: ls.get('anolectivo'),
    Listaranoslectivo: [],
    roles: 'func'
  }),

  computed: {

    idclasse() {
      return this.$store.state.idclasse
    },
    rotaBack() {
      return 'impressao/menu'
    }
  },

  created() {
    if (ls.get('role') === 'ROLE_COOR') { this.roles = 'coor' }
    this.initializeAnosLectivo()
    // Seta o anolectivo padrão
    this.$store.state.anolectivoSelecionado = this.anolectivoSelected
    this.$store.state.novadescricaoSelecionado = ls.get('novadescricao')
    this.$store.state.idclasse = null
  },

  methods: {
    classe(idclasse) {
      const ls = require('local-storage')
      this.$store.state.idclasse = idclasse
      if (idclasse === 1) {
        this.$store.state.classeTur = '10ªC-' + ls.get('anolectivo')
      } else if (idclasse === 2) {
        this.$store.state.classeTur = '11ªC-' + ls.get('anolectivo')
      } else if (idclasse === 3) {
        this.$store.state.classeTur = '12ªC-' + ls.get('anolectivo')
      } else if (idclasse === 4) {
        this.$store.state.classeTur = '13ªC-' + ls.get('anolectivo')
      }

      this.$router.push('/turma/listagem')
    },
    filtrarAnoLectivo() {
      this.$store.state.anolectivoSelecionado = this.anolectivoSelected.descricao
      this.$store.state.novadescricaoSelecionado = this.anolectivoSelected.novadescricao
    },

    async initializeAnosLectivo() {
      try {
        this.Listaranoslectivo = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
      } catch (error) {
         this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      } finally {
      }
    }
  }
}
</script>
